import { useAuth } from '@shared/components/AuthProvider';

export const useSignIn = () => {
  const { loginManager } = useAuth();

  const signIn = async () => {
    // Take user to login screen. with a redirect back to the current page after completion.
    await loginManager.authService.authorize(window.location.href);
  };

  return { signIn };
};
